import React from "react";
import Delivery from "../assets/img/delivery.png";
import HeroBg from "../assets/img/heroBg.png";
import Discount from "../assets/img/discount.png";
import Logo from "../assets/img/logo.png";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useState } from "react";
import { getAllCartFromStaff, getAllCartItems, getCartFromStaff } from "../api";
import { setCartItems, setNumberOfCart } from "../context/actions/cartActions";
const HomeContainer = () => {
  const user = useSelector(state => state.user);
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const numberOfCartStaff = useSelector(state => state.cart.numberStaffCart)
  const selectedOrderNumber = useSelector(state => state.cart.selectedCart)
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (user?.role === "Staff") {

        } else {
          const data = await getAllCartItems(user?.user_id);
          dispatch(setCartItems(data));
        }

        setLoading(false);
      } catch (error) {
        console.error("Error fetching cart items:", error);
        setLoading(false); // Make sure to set loading to false in case of an error
      }
    };
    fetchData();
  }, [dispatch, user]);

  const handleFetchNumberCart = async () => {
    await getAllCartFromStaff(user?.user_id).then((data) => {
      dispatch(setNumberOfCart(data.numberOfOrderNumbers));
    })
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        if (user?.role === "Staff") {
          const data = await getCartFromStaff(user?.user_id, selectedOrderNumber);
          dispatch(setCartItems(data.data));
          handleFetchNumberCart();
        } else {
          const data = await getAllCartItems(user?.user_id);
          dispatch(setCartItems(data));
        }
        setLoading(false);
      } catch (error) {
        console.error("Error fetching cart items:", error);
        setLoading(false); // Make sure to set loading to false in case of an error
      }
    };
    fetchData();
  }, [dispatch, user, selectedOrderNumber, numberOfCartStaff]);

  return (
    <section
      className="grid grid-cols-1 md:grid-cols-2 gap-2 w-full "
      id="home"
    >
      <div className="py-2 flex-1 flex flex-col items-start justify-center gap-6">
        <div className="flex items-center gap-2 justify-center bg-orange-100 px-4 py-1 rounded-full">
          <p className="text-base text-orange-500 font-semibold">
            Ship hàng online
          </p>
          <div className="w-8 h-8 bg-white rounded-full overflow-hidden drop-shadow-xl">
            <img
              src={Delivery}
              className="w-full h-full object-contain"
              alt="delivery"
            />
          </div>
        </div>

        <p className="text-[2.5rem] lg:text-[4.5rem] font-bold tracking-wide text-headingColor">
          Đặt hàng ngay bây giờ không thể dễ hơn với
          <span className="text-orange-600 text-[3rem] lg:text-[5rem]">
            <span className="relative text-red-600 left-0"><span className="opacity-0">Doo</span><span className="absolute left-0 animate-bounce">Doo</span></span><span className="text-blue-600">ha</span>
          </span>
        </p>

        <p className="text-base text-textColor text-center md:text-left md:w-[80%]">
        </p>

        {/* <button
          type="button"
          className="bg-gradient-to-br text-white from-orange-400 to-orange-500 w-full md:w-auto px-4 py-2  rounded-lg hover:shadow-lg transition-all ease-in-out duration-100"
        >
          Đặt hàng ngay
        </button> */}
      </div>
      <div className="py-2 flex-1 flex items-center relative">
        <img
          src={HeroBg}
          className="ml-auto h-600 w-full lg:w-full lg:h-650"
          alt="hero-bg"
        />

        <div className="w-full h-full absolute top-0 left-0 flex items-center justify-center lg:px-24  py-4 gap-4 flex-wrap">
          <img src={Logo} alt="discount" />
        </div>
      </div>
    </section>
  );
};

export default HomeContainer;